import React from "react";
import { ChartProps } from "src/routes/ConnectedSensors/components/ConnectedPage";
import { Box, styled, Typography } from "@mui/material";
import { Colors, DEFAULT_Y_AXIS_DOMAIN_HUMIDITY, ParamTooltipTypes, units, SensorChartGraphHeight } from "src/system/constants";
import ConnectedChart from "./ConnectedChart";

const ConnectedHumidity: React.FC<ChartProps> = ({ data }) => {
  return (
    <>
      <ChartBox>
        <Typography>
          Humidity <ChartBoxText>%</ChartBoxText>
        </Typography>
      </ChartBox>
      <ConnectedChart
        averageChartItems = {[
          {name: ParamTooltipTypes.HUMIDITY, unit: units.Hum}
        ]}
        chartType = {ParamTooltipTypes.HUMIDITY}
        chartUnit = {units.Hum}
        chartDomain = {DEFAULT_Y_AXIS_DOMAIN_HUMIDITY}
        graphHeight = {SensorChartGraphHeight.NORMAL}
        strokeColor = {Colors.heavenly}
        areaColor = {Colors.heavenly}
        grid
        yAxis
        spaceBeforeUnit = {false}
      />
    </>
  );
};

const ChartBox = styled(Box)({
  padding: "0",
  display: "flex",
  justifyContent: "space-between",
  "& p": {
    fontSize: "22px",
    fontWeight: "500",
    marginBottom: "20px",
  },
});

const ChartBoxText = styled(Box)({
  padding: "0 0 0 0",
  display: "inline-block",
  color: Colors.gray,
});

export default ConnectedHumidity;
